import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareFromSquare } from "@fortawesome/free-solid-svg-icons";
import {
  faTwitter,
  faFacebook,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { FacebookShareButton, TwitterShareButton } from "react-share";

const DropdownButton = ({ shareUrl, estado }) => {
  // Mensajes dinámicos según el estado
  const getShareContent = (estado) => {
    switch (estado) {
      case 1:
        return {
          title: "🚨 ¡Mascota perdida! Ayudanos a encontrarla 🐾",
          hashtags: ["BuscaTuAmigo", "MascotaPerdida", "Uruguay"],
        };
      case 3:
        return {
          title: "🙌 Encontramos a esta mascota. ¿La reconocés?",
          hashtags: ["BuscaTuAmigo", "MascotaEncontrada", "Uruguay"],
        };
      case 4:
        return {
          title: "🏡 Esta mascota está buscando familia. ¡Adoptá con amor!",
          hashtags: ["BuscaTuAmigo", "AdoptaNoCompres", "MascotasUY"],
        };
      case 2:
        return {
          title: "🎉 ¡Esta mascota ya fue adoptada! Gracias por compartir 🧡",
          hashtags: ["BuscaTuAmigo", "FinalFeliz", "AdopcionResponsable"],
        };
      default:
        return {
          title: "Busca-tu-amigo tiene una noticia para darte",
          hashtags: ["BuscaTuAmigo", "Rescate"],
        };
    }
  };

  const { title, hashtags } = getShareContent(estado);

  return (
    <div className="relative inline-block group">
      <button className="w-[50px] h-[45px] px-4 py-2 bg-white border rounded-md transition-colors group-hover:bg-secondary group-hover:text-white group-hover:rounded-none group-hover:rounded-bl group-hover:rounded-br">
        <FontAwesomeIcon icon={faShareFromSquare} />
      </button>

      <div className="absolute w-[50px] hidden group-hover:block bottom-full left-0 bg-white border border-gray-300 shadow-lg mt-2 rounded z-10 group-hover:rounded-none group-hover:rounded-tr group-hover:rounded-tl">
        <div className="px-4 py-2 cursor-pointer hover:bg-gray-200 transition-colors rounded">
          <FacebookShareButton
            url={shareUrl}
            quote={title}
            className="flex items-center"
          >
            <FontAwesomeIcon icon={faFacebook} size="lg" />
          </FacebookShareButton>
        </div>

        <div className="px-4 py-2 cursor-pointer hover:bg-gray-200 transition-colors rounded">
          <TwitterShareButton
            url={shareUrl}
            title={title}
            hashtags={hashtags}
            related={["buscatuamigoUY"]}
            className="flex items-center"
          >
            <FontAwesomeIcon icon={faTwitter} size="lg" />
          </TwitterShareButton>
        </div>

        <div className="px-4 py-2 cursor-pointer hover:bg-gray-200 transition-colors rounded">
          <a
            href="https://www.instagram.com/buscatuamigo/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block flex items-center"
          >
            <FontAwesomeIcon icon={faInstagram} size="lg" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default DropdownButton;
